/* eslint-disable no-undef */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { compose } from "redux";
import AuthService from "../../services/AuthService";
import * as authAction from "../../actions/auth";
import MasterService from "../../services/MasterService";
import ToastService from "../../services/ToastService";

const required = (value, name) => {
  if (!value) {
    return (
      <div className="isaerror" role="alert">
        Please enter your {name}
      </div>
    );
  }
};

const ResetPassword = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [pwdValidation, setPwdValidation] = useState([]);
  const [email, setEmail] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [selectedRole, setSelectedRole] = useState(0);
  const [categories, setCategories] = useState([]);
  const [countries, setCountries] = useState([]);
  const [roles] = useState([
    { id: "contributor", name: "Practitioner" },
    { id: "editor", name: "Mission User" },
    { id: "subscriber", name: "Public User" },
    { id: "ayush_chair", name: "Ayush Chairs" },
    { id: "association_user", name: "Association User" },
  ]);
  const [authImage, setAuthImage] = useState([]);
  const [tNc, setTNc] = useState(false);

  const history = useHistory();

  useEffect(() => {
    fetchCountries();
    fetchAuthImage();
  }, []);

  const fetchAuthImage = async () => {
    try {
      const result = await AuthService.getAuthImage();
      if (result) {
        const authImageLoc = result.data[0].images?.map(item => ({
          backgroundImage: `url(${item})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        })) || [];
        setAuthImage(authImageLoc);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCountries = async () => {
    try {
      const result = await MasterService.getAyushCountries();
      if (result) {
        setCountries(result);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCategories = async () => {
    try {
      const result = await MasterService.getCategories();
      if (result) {
        setCategories(result);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const validatePassword = (value, name) => {
    const pwdPattern = new RegExp(/(?=.*?[A-Za-z])(?=.*?[0-9])(?=.*?[@$!%*#?~(&)+=^_-]).{8,}/);
    const validationErrors = [...pwdValidation];
    if (!pwdPattern.test(value) || value.length < 8) {
      validationErrors[name] = (
        <div className="isaerror" role="alert">
          Password must be at least 8 characters long, include letters, numbers, & 1 special character.
        </div>
      );
    } else {
      validationErrors[name] = "";
    }
    setPwdValidation(validationErrors);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    const data = {
      user_login: username,
      user_pass: password,
      user_email: email,
      blog_id: selectedCountry,
      user_role: selectedRole,
      user_category: selectedCategory,
    };

    if (
      username &&
      password &&
      email &&
      selectedCountry &&
      tNc &&
      (selectedRole === "contributor" ? selectedCategory : selectedRole)
    ) {
      try {
        const result = await AuthService.register(data);
        if (result?.status === 200) {
          ToastService.success("Signed up successfully!");
          history.push("/login");
        } else {
          ToastService.error(result.data[0]);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") setUsername(value);
    if (name === "password") {
      setPassword(value);
      validatePassword(value, "password");
    }
    if (name === "confirmPassword") setConfirmPassword(value);
    if (name === "email") setEmail(value);
  };

  const handleCheckboxChange = (e) => {
    setTNc(e.target.checked);
  };

  const handleSelectChange = (name, value) => {
    if (name === "selectedCountry") setSelectedCountry(value);
    if (name === "selectedCategory") setSelectedCategory(value);
    if (name === "selectedRole") {
      setSelectedRole(value);
      fetchCategories();
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <div style={bgshapestyle}>
        <div style={innerform}>
          <div style={loginbox}>
            <h1 style={colorhd}>Reset Password</h1>
            <form onSubmit={handleResetPassword}>
              <div>
                <label htmlFor="username">Username:</label>
                <input
                  type="text"
                  id="username"
                  name="username"
                  value={username}
                  onChange={handleChange}
                  required
                />
                {required(username, "username")}
              </div>
              <div>
                <label htmlFor="email">Email:</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={handleChange}
                  required
                />
                {required(email, "email")}
              </div>
              <div>
                <label htmlFor="password">Password:</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={handleChange}
                  required
                />
                {pwdValidation.password}
              </div>
              <div>
                <label htmlFor="confirmPassword">Confirm Password:</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                    if (password !== e.target.value) {
                      setPwdValidation(prev => ({
                        ...prev,
                        pwdConfirm: (
                          <div className="isaerror" role="alert">
                            Confirm password does not match
                          </div>
                        ),
                      }));
                    } else {
                      setPwdValidation(prev => ({
                        ...prev,
                        pwdConfirm: "",
                      }));
                    }
                  }}
                  required
                />
                {pwdValidation.pwdConfirm}
              </div>
              <div>
                <label htmlFor="country">Country:</label>
                <select
                  id="country"
                  value={selectedCountry}
                  onChange={(e) => handleSelectChange("selectedCountry", e.target.value)}
                >
                  <option value="0">Select Country</option>
                  {countries.map(country => (
                    <option key={country.id} value={country.id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="role">Role:</label>
                <select
                  id="role"
                  value={selectedRole}
                  onChange={(e) => handleSelectChange("selectedRole", e.target.value)}
                >
                  <option value="0">Select Role</option>
                  {roles.map(role => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>
              {selectedRole === "contributor" && (
                <div>
                  <label htmlFor="category">Category:</label>
                  <select
                    id="category"
                    value={selectedCategory}
                    onChange={(e) => handleSelectChange("selectedCategory", e.target.value)}
                  >
                    <option value="0">Select Category</option>
                    {categories.map(category => (
                      <option key={category.id} value={category.id}>
                        {category.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div>
                <input
                  type="checkbox"
                  id="tNc"
                  checked={tNc}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="tNc">I agree to the terms and conditions</label>
              </div>
              <button type="submit">Reset Password</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translation: state.translation,
});

const mapDispatchToProps = (dispatch) => ({
  userDetail: (user) => dispatch(authAction.userDetail(user)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(ResetPassword);
